import React, { FC, isValidElement, useMemo, } from "react";
import classNames from "classnames";
import { ScanPageProps, ScanPageItemEnum, } from "./interface";
import './style.less';

const ScanPage: FC<ScanPageProps> = props => {
  const { children, className, style, } = props;
  // const renderInfo = useMemo(() => {
  //   return React.Children.map(children, child => {
  //     const childElement = child as React.FunctionComponentElement<ScanPageProps>;
  //     if (!isValidElement(childElement)) return null;
  //     if (!childElement.type) return null;
  //     const { displayName } = childElement.type;
  //     if (displayName && displayName in ScanPageItemEnum) {
  //       return childElement;
  //     } else {
  //       console.error(
  //         'Warning: ScanPage has a child which is not a Left and Content or Right component',
  //       );
  //     }
  //   });
  // }, [children]);
  const classes = classNames('yb-scan-page', className);
  return (
    <div className={classes} style={style}>{children}</div>
  );
};

export default ScanPage;